import apiUtils from "./apiUtils";

const fetchAllCategories = async () => {
    return apiUtils.get(
        '/api/categories', 
        'Не удалось получить информацию о категориях товаров'
    );
};

const fetchTopCategories = async () => {
    return apiUtils.get(
        '/api/categories/top', 
        'Не удалось получить информацию о категориях товаров'
    );
};

const deleteCategory = async (categoryId, forceDelete) => {
    return apiUtils.delete(
        `/api/categories/${categoryId}?forceDelete=${forceDelete}`,
        'Ошибка при удалении категории товаров'
    );
};

const fetchCategoryById = async (id) => {
    return apiUtils.get(
        `/api/categories/${id}`, 
        'Не удалось получить информацию о категории'
    );
};

const updateCategory = async (categoryId, categoryData) => {
    return apiUtils.put(
        `/api/categories/${categoryId}`,
        categoryData,
        'Ошибка при обновлении категории товаров',
        true
    );
};

const createCategory = async (categoryData) => {
    return apiUtils.post(
        `/api/categories`,
        categoryData,
        'Ошибка при создании категории товаров',
        true
    );
};

const updateCategoryOrder = async (categoriesOrder) => {
    return await apiUtils.put(
        '/api/categories/reorder', 
        categoriesOrder, 
        'Ошибка при обновлении порядка категорий'
    );
};

export default { fetchAllCategories, fetchTopCategories, deleteCategory, fetchCategoryById, updateCategory, createCategory, updateCategoryOrder };